import React from 'react'

import { AdminContext } from 'contexts/AdminContext'

import { Form } from '_zari/core'

import { DateHandler } from 'utils'

const FechaDocumentoFormGroup = ({ id, name, onChange, onBlur, ...props }) => {
  const __adminContext = React.useContext(AdminContext)

  const delayRef = React.useRef()
  const [searchText, setSearchText] = React.useState(props.value || '')

  const convertirFormatoLargo = React.useCallback(fecha => {
    const splited = fecha.split(DateHandler._DIVIDERSYMBOL)
    const yearValue = parseFloat(splited[2])
    const newYearValue = yearValue < 1000 ? yearValue + 2000 : yearValue

    const nuevaFecha = `${splited[0]}${DateHandler._DIVIDERSYMBOL}${splited[1]}${DateHandler._DIVIDERSYMBOL}${newYearValue}`
    return nuevaFecha
  }, [])

  React.useEffect(() => {
    if (searchText !== null) {
      delayRef.current = setTimeout(() => {
        if (DateHandler.isValidString(searchText)) {
          const nuevaFecha = convertirFormatoLargo(searchText)

          onChange({
            target: {
              id: id,
              name: name,
              value: nuevaFecha
            }
          })
        }
      }, 500)
      return () => clearTimeout(delayRef.current)
    }
  }, [searchText, onChange, id, name, convertirFormatoLargo])

  const innerOnChange = React.useCallback(e => {
    setSearchText(e.target.value)
  }, [])

  const clearOnBlur = React.useCallback(
    e => {
      setSearchText('')

      if (onBlur) {
        e.target.value = ''
        onBlur(e)
      }

      if (onChange) {
        onChange({
          target: {
            id: id,
            name: name,
            value: ''
          }
        })
      }
    },
    [onBlur, onChange, id, name]
  )

  const innerOnBlur = React.useCallback(
    e => {
      if (!DateHandler.isValidString(searchText)) {
        if (searchText.length <= 2 && searchText.length > 0) {
          const intValue = parseInt(searchText)
          if (intValue <= 31 && intValue > 0) {
            const nuevaFecha = `${`${intValue}`.padStart(2, '0')}${DateHandler._DIVIDERSYMBOL}${
              __adminContext.mesTrabajo
            }${DateHandler._DIVIDERSYMBOL}${__adminContext.anioTrabajo}`

            setSearchText(nuevaFecha)
            if (onBlur) {
              e.target.value = nuevaFecha
              onBlur(e)
            }

            if (onChange) {
              onChange({
                target: {
                  id: id,
                  name: name,
                  value: nuevaFecha
                }
              })
            }
          } else {
            clearOnBlur(e)
          }
        } else {
          clearOnBlur(e)
        }
      } else {
        const nuevaFecha = convertirFormatoLargo(searchText)
        setSearchText(nuevaFecha)
        if (onBlur) {
          e.target.value = nuevaFecha
          onBlur(e)
        }
      }
    },
    [onBlur, searchText, __adminContext, convertirFormatoLargo, onChange, id, name, clearOnBlur]
  )

  return (
    <Form.InputText
      {...props}
      id={id}
      name={name}
      onChange={innerOnChange}
      onBlur={innerOnBlur}
      value={searchText}
      maxLength={10}
    />
  )
}

export default React.memo(FechaDocumentoFormGroup)
